<template>
  <div class="ingredient-chapter">
    <div class="background"></div>
    <div class="scroll-wrapper" ref="scrollWrapper">
      <div class="content">
        <div class="back" @click="doClose">
          <div class="icon"></div>
          <div class="text">{{ t("back") }}</div>
        </div>
        <template v-if="loaded">
          <div class="subsection main">
            <div class="info">
              <FamiliesWithIcon
                :family="data.family"
                :subfamily="data.secondaryFamily"
              ></FamiliesWithIcon>
              <div class="ing-title">{{ data.name }}</div>
              <div class="ing-description">{{ data.description }}</div>
              <div
                v-if="data.type || data.parts || data.extraction"
                class="props"
              >
                <div v-if="data.type" class="prop">
                  <div class="prop-title">{{ t("ingredient_type") }}</div>
                  <div class="prop-value">{{ data.type }}</div>
                </div>
                <div v-if="data.parts" class="prop">
                  <div class="prop-title">{{ t("ingredient_parts") }}</div>
                  <div class="prop-value">{{ data.parts }}</div>
                </div>
                <div v-if="data.extraction" class="prop">
                  <div class="prop-title">{{ t("ingredient_extraction") }}</div>
                  <div class="prop-value">{{ data.extraction }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- HISTORY -->
          <div
            v-if="data.history || data.imageUrlM || data.lightImageUrl"
            class="subsection history-subsection"
          >
            <div class="image-wrapper">
              <img
                class="img"
                :src="
                  data.lightImageUrlM ||
                  data.lightImageUrl ||
                  data.imageUrlM ||
                  data.imageUrl
                "
                :alt="data.name"
              />
            </div>
            <div v-if="data.history" class="element history">
              <div class="title">{{ t("history") }}</div>
              <div class="subsection-content" v-html="data.history"></div>
            </div>
          </div>
          <!-- IMAGE -->
          <div
            v-if="data.otherImageUrlL || data.otherImageUrl"
            class="subsection image"
          >
            <img
              :src="data.otherImageUrlL || data.otherImageUrl"
              :alt="data.name"
            />
          </div>
          <!-- PRODUCTION -->
          <div v-if="data.production" class="subsection descs">
            <div class="element production">
              <div class="title">{{ t("production") }}</div>
              <div class="subsection-content" v-html="data.production"></div>
            </div>
          </div>
          <!-- IMAGE -->
          <div
            v-if="
              data.detailImageUrl1M ||
              data.detailImageUrl1 ||
              data.detailImageUrl2M ||
              data.detailImageUrl2
            "
            class="subsection image"
          >
            <img
              v-if="data.detailImageUrl1M || data.detailImageUrl1"
              :src="data.detailImageUrl1M || data.detailImageUrl1"
              :alt="data.name"
            />
            <img
              v-if="data.detailImageUrl2M || data.detailImageUrl2"
              :src="data.detailImageUrl2M || data.detailImageUrl2"
              :alt="data.name"
            />
          </div>
          <!-- ICONIC FRAGRANCE -->
          <div
            v-if="data.iconicPerfume && data.iconicFraganceText"
            class="subsection descs"
          >
            <div class="element iconic-fragrance">
              <div class="subsection-content">
                <div class="iconic-perfume">
                  <div v-if="iconicPerfume" class="element iconic">
                    <div class="title">{{ t("ingredient_first") }}</div>
                    <IconicPerfumeCard
                      v-if="!isMobile"
                      @click="goToPerfume(iconicPerfume)"
                      :data="iconicPerfume"
                    ></IconicPerfumeCard>
                    <div v-else-if="iconicPerfume">
                      <PerfumeCard
                        class="perfume-card"
                        :data="iconicPerfume"
                      ></PerfumeCard>
                      <!--<SquareButton @click ="goToPerfume(iconicPerfume)">{{t("show_similar")}}</SquareButton>-->
                    </div>
                  </div>
                </div>
                <div v-if="iconicPerfume" class="title">
                  {{ t("iconic_fragrance") }}
                </div>
                <!-- TODO: Improve this if isMobile -->

                <div v-if="isMobile" class="title">
                  {{ t("iconic_fragrance") }}
                </div>
                <!-- TODO: Improve this if isMobile -->
                <div
                  class="subsection-sub-content"
                  v-html="data.iconicFraganceText"
                ></div>
              </div>
            </div>
          </div>
          <div class="separator"></div>
          <!-- EFFECT AND MORE INFO -->

          <div v-if="data.effect || data.moreInfo" class="subsection descs">
            <div class="effect-more">
              <div v-if="data.effect" class="effect">
                <div class="title">{{ t("effect") }}</div>
                <div class="subsection-content" v-html="data.effect"></div>
              </div>
              <div v-if="data.moreInfo" class="more-info">
                <div class="title">{{ t("did_you_know") }}</div>
                <div class="subsection-content" v-html="data.didYouKnow"></div>
              </div>
            </div>
          </div>
          <!-- IMAGE -->
          <div
            v-if="
              data.surroundingsImageUrl1M ||
              data.surroundingsImageUrl1 ||
              data.surroundingsImageUrl2M ||
              data.surroundingsImageUrl2
            "
            class="subsection image"
          >
            <img
              v-if="data.surroundingsImageUrl1M || data.surroundingsImageUrl1"
              :src="data.surroundingsImageUrl1M || data.surroundingsImageUrl1"
              :alt="data.name"
            />
            <img
              v-if="data.surroundingsImageUrl2M || data.surroundingsImageUrl2"
              :src="data.surroundingsImageUrl2M || data.surroundingsImageUrl2"
              :alt="data.name"
            />
          </div>
          <!-- MAP -->
          <div
            v-if="data.origin && data.origin.length > 0"
            class="subsection map"
          >
            <div class="map-origin">
              <div class="title">{{ t("origin") }}</div>
              <ul>
                <li
                  class="list-element"
                  v-for="(e, index) of mapPoints"
                  :key="e.name"
                  :class="getClassPoint(index, mapPoints.length)"
                >
                  <!--<div class="position-icon"></div>-->
                  <div class="place">{{ e.name }}</div>
                </li>
              </ul>
            </div>
            <div class="world-map">
              <WorldMap :points="mapPoints"></WorldMap>
            </div>
          </div>
        </template>
      </div>
    </div>
    <transition name="fade">
      <div v-if="selectedPerfume" class="overlay">
        <PerfumeAndSimilars
          :data="selectedPerfume"
          @close="selectedPerfume = null"
        ></PerfumeAndSimilars>
      </div>
    </transition>
  </div>
</template>

<script>
import { getPerfume } from "@/services/Api";
import PerfumeCard from "@/components/PerfumeCard";
import IconicPerfumeCard from "@/components/IconicPerfumeCard";
import FamiliesWithIcon from "@/components/FamiliesWithIcon";
import WorldMap from "@/components/WorldMap";
import PerfumeAndSimilars from "@/components/PerfumeAndSimilars";
import { RouteNames } from "../router";
export default {
  name: "IngredientChapter",
  props: [],
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.description,
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: `Wikiparfum - ${this.title}`,
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.description,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: `Wikiparfum - ${this.title}`,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
      ],
    };
  },
  components: {
    PerfumeCard,
    WorldMap,
    FamiliesWithIcon,
    PerfumeAndSimilars,
    IconicPerfumeCard,
  },
  routerLinkedData: ["data", "selectedPerfume"],
  lazyData: {
    data: {
      type: "ingredientMeta",
    },
    selectedPerfume: { type: "perfume" },
  },
  asyncComputed: {
    iconicPerfume() {
      if (this.data.iconicPerfume) return getPerfume(this.data.iconicPerfume);
      return Promise.resolve(null);
    },
  },
  computed: {
    loaded() {
      return this.data.name;
    },
    title() {
      return this.data && this.data.name
        ? ` Information for the fragrance ${this.data.name}`
        : "Raw materials";
    },
    description() {
      return this.data && this.data.description ? this.data.description : "";
    },
    mapPoints() {
      /**
       * COORS is array of undefined,undefined
       */
      return this.data.origin.map((e, index) => ({
        ...e,
        color: this.getMapColor(index, this.data.origin.length),
        coord: [e.long, e.lat],
      }));
    },
  },
  methods: {
    setNewTarget(target) {
      if (target.isIngredientChapter)
        this.$router.push({name:RouteNames.IngredientChapter, query:{data: target.id}});
        // this.$router.push(`/chapter/ingredient?data=${target.id}`);
      //this.data = target.id
    },
    goToPerfume(target) {
      // console.log("target",target)
      this.selectedPerfume = target.id;
    },
    doClose() {
      this.$router.go(-1);
    },

    getClassPoint(index, total) {
      if (index === 0) return { green: true }; //green
      if (index === total - 1) return { red: true };
      //red
      else return { blue: true };
    },
    getMapColor(index, total) {
      if (index === 0) return "green"; //green
      if (index === total - 1) return "#fb5555";
      //red
      else return "blue";
    },
  },
  watch: {
    data(data) {
      if (data._loaded) {
        this.eventTracker.emitEvent("VIEW_OPENED", {
          type: "INGREDIENT_VIEWED",
          data: { id: data.id },
        });
      }
      this.$refs.scrollWrapper.scrollTop = 0;
    },
  },
};
</script>

<style scoped lang="stylus">
.warn
  color: red

.ingredient-chapter
  // overflow-y: auto
  position: absolute
  top: 0
  z-index: 11
  width: 100%
  height: 100%
  background-image: url("~@/assets/images/V4_desktop.jpg")
  background-position: center center
  background-size: cover
  background-repeat: no-repeat

  .title
    m-font-size(20, 22)

  .scroll-wrapper
    position: relative
    overflow-y: auto
    height: 100%

    .content
      position: relative
      m-max-width-container(padding: 5%)
      height: 100%

    .separator
      max-width: vw(900px)
      width: 100%
      border-bottom: 2px solid rgba(0, 0, 0, 0.15)

    .subsection
      .element
        .title
          margin-bottom: vh(20px)

      &.main
        .info
          display: flex
          flex: 1 1 0%
          flex-direction: column
          align-items: center
          padding-top: vh(100px)

        .ing-description
          m-font-size(18, 28)
          margin-top: vh(30px)
          max-width: vw(550px)
          text-align: center

          .mobile &
            padding: 0 vw(20px)

        .ing-title
          m-font-size(70, 77)
          margin: vh(20px) 0

          .mobile &
            m-font-size(50, 60)
            margin: vh(30px) 0

        .family-and-icon
          >>> .label
            m-font-size(16, 16)

        .props
          display: flex
          margin: vh(50px) 0
          width: 100%

          .mobile &
            display: block

        .prop
          display: flex
          flex: 0 0 percentage((1 / 3))
          flex-direction: column
          align-items: center

          .mobile &
            margin: vh(20px) auto

        .prop-title
          m-font-size(12, 16)
          margin-bottom: vh(5px)

        .prop-value
          m-font-size(16, 16)
          text-align: center

      &.image
        > img
          padding: vw(10px)
          width: 50%

          &:only-child
            width: 100%

          .mobile &
            width: 100%

      &.history-subsection
        display: flex

        .mobile &
          flex-direction: column

        .image-wrapper
          margin: auto
          width: 50%

          .mobile &
            width: 100%
            height: vh(600px)

        .img
          max-width: vw(600px)
          width: 100%
          background-position: center
          background-size: contain
          background-repeat: no-repeat

          .mobile &
            height: 100%

        .history
          m-font-size(14, 24)
          padding: vw(20px)
          max-width: vw(500px)
          width: 50%
          height: 100%
          white-space: pre-line

          .mobile &
            width: 100%
            border: none
            border-bottom: $border

        .title
          m-font-size(24, 26)

        .subsection-content
          m-font-size(16, 26)

      &.descs
        flex: 1 1 0%
        flex-direction: column
        align-items: center
        margin-bottom: vh(30px)
        width: 100%

        .title
          m-font-size(24, 26)
          text-align: left

          .mobile &
            margin-top: vh(100px)

        .subsection-content
          m-font-size(16, 26)

        .production
          flex: 1 1 0%
          margin: vh(20px) auto
          max-width: vw(600px)
          max-width: vw(600px)
          width: 100%

        .iconic-fragrance
          flex: 1 1 0%
          width: 100%

          .title
            m-font-size(24, 26)
            text-align: left

            .mobile &
              margin-top: vh(100px)

        .subsection-content
          m-font-size(16, 26)

        .iconic-perfume
          float: left
          margin: 0 vh(20px) vh(10px) 0

          .mobile &
            float: none

          .perfume-card
            .mobile &
              align-items: center
              width: 100%
              height: vh(800px)
              border: none

          .title
            m-font-size(16, 18)
            text-align: left

        .effect-more
          display: flex
          flex-direction: column
          justify-content: space-around
          align-items: center
          margin: auto
          max-width: vw(600px)
          width: 100%

          .mobile &
            flex-direction: column

        .effect,
        .more-info
          display: inline-block
          flex: 1 1 0%
          height: 100%

          .mobile &
            margin: vh(50px) 0

          .title
            m-font-size(24, 26)
            margin: vh(20px) 0

          .subsection-content
            m-font-size(16, 26)
            white-space: pre-line

          .value
            m-font-size(16, 16)

      &.map
        position: relative
        height: vh(600px)

        .mobile &
          flex-direction: column

        .title
          m-font-size(24, 26)
          text-align: center

          .mobile &
            margin-bottom: vh(50px)

        .map-origin
          position: absolute
          bottom: 0
          left: 0
          flex: 1 1 30%
          padding: vh(20px) vw(15px)

          .mobile &
            position: relative

          ul
            .mobile &
              display: flex
              flex-wrap: wrap

          li
            .mobile &
              width: 50%

          .title
            margin-bottom: vh(20px)

          .green
            &:before
              background: url("~@/assets/icons/icon-map-macker-green.svg") no-repeat left 10px

          .blue
            &:before
              background: url("~@/assets/icons/icon-map-macker-blue.svg") no-repeat left 10px

          .red
            &:before
              background: url("~@/assets/icons/icon-map-macker-red.svg") no-repeat left 10px

        .list-element
          position: relative
          margin-left: 1.5em

          &:before
            position: absolute
            top: 0
            left: 0
            margin-left: -1.5em
            width: 1em
            height: 1em
            background-position: center
            content: ""

          .position-icon
            m-icon("map-macker", 30)
            display: inline-block
            width: vh(15px)
            height: vh(15px)

          .place
            display: inline-block

        .world-map
          width: 100%
          height: 100%

          .mobile &
            height: vh(300px)

          svg
            background-color: #fff

      &.perfumes,
      &.ingredients
        display: block
        padding: vh(50px) 0
        border-bottom: $border

        .header
          display: flex
          margin-bottom: vh(30px)

          .mobile &
            margin: vh(30px) 0
            width: 100%
            text-align: center

        .flex-grow
          flex-grow: 1

        .explore
          m-font-size(14, 16)
          display: flex
          align-items: center
          cursor: pointer

          .arrow
            m-icon("big-arrow", 10)
            margin-left: vw(10px)

        .btn
          margin: vh(20px) auto
          width: vw(300px)

        .perfumes-wrapper
          display: flex
          flex-wrap: wrap
          justify-content: center

        .ingredient-card
          margin: vh(10px) vw(10px)
          width: vw(190px)

          &.clicked
            cursor: pointer

          .mobile &
            margin: vh(10px) auto
            width: 50%

        .perfume-card
          margin: vh(10px) vw(10px)
          width: vw(190px)
          height: vh(300px)

          .mobile &
            margin: vh(10px) auto
            width: 47%
            height: vh(400px)

  .back
    position: fixed
    top: "calc(%s + %s)" % ($header-height vw(60px))
    display: flex
    align-items: center
    padding: vw(8px) vw(16px)
    background-color: #fff
    cursor: pointer

    .icon
      m-icon("chevron-left", 18)
      margin-right: vw(8px)

    .text
      m-font-size(14, 22)
      m-letter-spacing(20)
      color: $golden

  .overlay
    position: absolute
    top: 0
    width: 100%
    height: 100%

    &.fade-enter-active,
    &.fade-leave-active
      transition: opacity 0.4s

    &.fade-enter,
    &.fade-leave-to
      opacity: 0
</style>